import React, { Suspense, useState } from 'react';

import { ExpandCard } from '@eika/expand-card';

import useTranslation, { formatJsx } from '../../hooks/useTranslation';
import { pushTrackIDs } from '../../utils/gtm/trackIDs/push';
import NotificationSwitches from './components/NotificationSwitches';
import NotificationSwitchesSkeleton from './components/skeleton/NotificationSwitchesSkeleton';

import './components/NotificationsSettings.scss';

const NotificationsSettings: React.FC = () => {
    const translated = useTranslation();
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    return (
        <div>
            <Suspense fallback={<NotificationSwitchesSkeleton />}>
                <NotificationSwitches />
            </Suspense>
            <div className="sgw-content notifications-settings__gdpr-message">
                <ExpandCard
                    title={translated.pushNotifications.gdprTitle}
                    id="personvern-pushvarsel"
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                    dataTrackId={pushTrackIDs.privacy}
                >
                    <span className="notifications-settings__gdpr-message--text">
                        {formatJsx(
                            translated.pushNotifications.gdprDescription,
                            <span className="notifications-settings__gdpr-message--location">
                                {translated.pushNotifications.location}
                            </span>,
                        )}
                    </span>
                </ExpandCard>
            </div>
        </div>
    );
};

export default NotificationsSettings;
